// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"styles_loadingContainer__8Duku","whiteframe":"styles_whiteframe__2ro3s","filler":"styles_filler__9ar1u"};